/**
 * A transport failure is a request that never got an HTTP response: the browser
 * aborted it (route change, tab close, back button while it was in flight), the
 * device was offline or handed over between networks, an extension or corporate
 * proxy blocked it, or the connection was reset.
 *
 * `error.response` is populated as soon as response headers arrive, so its
 * absence — combined with a request object, which rules out a config/setup
 * error thrown before anything was sent — is the signal. Axios reports all of
 * these as the same opaque "Network Error", with no status and no body.
 *
 * There is nothing on our side to act on in one of these, so callers should
 * degrade instead of failing, and reporting should not treat them as exceptions.
 */
export function isTransportFailure (error) {
  return Boolean(error) && !error.response && Boolean(error.request)
}
